"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class UserNotFoundError extends client_library_1.ExtendableError {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : `User not found`);
    }
}
exports.default = UserNotFoundError;
//# sourceMappingURL=NotFoundError.js.map